export enum StatisticType {
  LIST_OF_TRADES = 'LIST_OF_TRADES',
  SUM_AMOUNT_OF_TRADES = 'SUM_AMOUNT_OF_TRADES',
  PEAKS_AMOUNT_OF_TRADES = 'PEAKS_AMOUNT_OF_TRADES',
  AVERAGE_AMOUNT_OF_TRADES = 'AVERAGE_AMOUNT_OF_TRADES'
}
